import { FiltersConfig } from '../types.js'

export const buildFiltersOptions = (filtersConfig: FiltersConfig | undefined): FiltersConfig => {
  return {
    header: false,
    ...filtersConfig
  }
}
